import carreraCustom, { createMountedPackagesAddToCartWithRedirect } from '../0acv10-4u/config.js';

window.Convermax.mountedPackagesAddToCartWithRedirect =
  createMountedPackagesAddToCartWithRedirect('/collections/tires/');

export default {
  ...carreraCustom,
  includes: [...carreraCustom.includes, '0acv10-4u'],
  Widgets: [
    ...carreraCustom.Widgets.map((w) => {
      if (w.name === 'HomeVehicleWidget_tab') {
        return { ...w, columnBreakpoint: 877 };
      }

      if (w.name === 'SearchVehicleWidget') {
        return {
          ...w,
          isVehicleSelectionIsolated: true,
        };
      }

      return w;
    }),
  ],
};
